var _a;
import { createSlice } from '@reduxjs/toolkit';
const stored = JSON.parse((_a = localStorage.getItem("rea-download-favorites")) !== null && _a !== void 0 ? _a : "[]");
const initialState = {
    favorites: stored !== null && stored !== void 0 ? stored : [],
};
export const fileSlice = createSlice({
    name: 'file',
    initialState,
    reducers: {
        add: (state, action) => {
            state.favorites = [...state.favorites, action.payload];
        },
        remove: (state, action) => {
            state.favorites = state.favorites.filter(item => item.id !== action.payload);
        },
        clear: (state) => {
            state.favorites = [];
        },
    },
});
export const { add, remove, clear } = fileSlice.actions;
export default fileSlice.reducer;
